import { get } from "./api";

export const getMonthData = (id, formattedDate, type, signal) => {
  const url = `/api/v2/customers/${id}/vendorbreakdown/${formattedDate}/${
    type === "overhead" ? "overheadFull" : type
  }`;
  return get(url, {}, false, signal, true);
};

export const getYearData = (id, formattedDate, type, signal) => {
  const url = `/api/v2/customers/${id}/vendorexpensebreakdown/${formattedDate}/${
    type === "overhead" ? "overheads" : type
  }`;
  return get(url, {}, false, signal, true);
};

export const getGraphData = (id, formattedDate, selectedPeriod, type, signal) => {
  const url = `/api/v2/customers/${id}/expenseoverviewgraph/${type}/${selectedPeriod}/${formattedDate}/`;
  return get(url, {}, false, signal, true);
};

export const getAdvancedMetricGraphData = (id, formattedDate, type, signal, params={}) => {
  const url = `/api/v2/customers/${id}/advancedmetricstrend/${type}/${formattedDate}`;
  return get(url, params, false, signal, true);
};

export const getAdvancedMetricSummary = (id, formattedDate, type, signal, params={}) => {
  const url = `/api/v2/customers/${id}/advancedmetricssummary/${type}/${formattedDate}`;
  return get(url, params, false, signal, true);
};

export const getLucroInsights = (id, formattedDate, type, signal, params={}) => {
  const url = `/api/v2/customers/${id}/lucroinsights/${type}/${formattedDate}`;
  return get(url, params, false, signal, true);
};

export const getCategoryBreakdown = (id, formattedDate, group, signal, params = {}) => {
  const url = `/api/v2/customers/${id}/categorybreakdown/${formattedDate}/${group}/`;
  return get(url, params, false, signal, true);
};

export const getSaasAllAdvancedMetricGraphData = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/saas-advanced-metrics-trend/${formattedDate}`;
  return get(url, params, false, signal, true);
};